<div class="card-wrapper">
  <div id="card-calendar" class="card p-0">
    <div class="card-body" appCalendarInteraction>
      <div id="shive-calendar">
        @defer (when finishedLoading()) {
          <app-shive-calendar-control-bar
            [calendarViewMode]="calendarViewMode"
          ></app-shive-calendar-control-bar>
          <table id="shive-outer-grid">
            <thead id="shive-calendar-header" [ngClass]="CalendarView[calendarViewMode]">
              <tr>
                <td>
                  <app-shive-calendar-header
                    [fixIntervalLanesLoaded$]="fixIntervalLanesLoaded$"
                  ></app-shive-calendar-header>
                </td>
              </tr>
            </thead>
            <tbody
              id="shive-calendar-body"
              class="scrollable"
              [ngClass]="CalendarView[calendarViewMode]"
            >
              <tr>
                <td>
                  @if (calendarViewMode === CalendarView.DayGrid) {
                    <app-day-view
                      [fixIntervalLanesLoaded$]="fixIntervalLanesLoaded$.asObservable()"
                    ></app-day-view>
                  }
                  @if (calendarViewMode === CalendarView.WeekGrid) {
                    <app-week-view
                      [fixIntervalLanesLoaded$]="fixIntervalLanesLoaded$.asObservable()"
                    ></app-week-view>
                  }
                  @if (calendarViewMode === CalendarView.MonthGrid) {
                    <app-month-view></app-month-view>
                  }
                </td>
              </tr>
            </tbody>
          </table>
        } @placeholder (minimum 500ms) {
          <app-calendar-skeleton-week-view />
        }
      </div>
    </div>
  </div>
</div>
